/*
 * This file is generated by the @wordpress/terrazzo-plugin-inline-alias-values plugin.
 * Do not edit this file directly.
 */

export default {
	transparent: [
		'background-interactive-brand-weak',
		'background-interactive-brand-weak-disabled',
		'background-interactive-error',
		'background-interactive-error-disabled',
		'background-interactive-error-weak',
		'background-interactive-error-weak-disabled',
		'background-interactive-neutral-weak',
		'background-interactive-neutral-weak-disabled',
	],
	'primary-bgFill1': [ 'background-interactive-brand-strong' ],
	'primary-bgFill2': [ 'background-interactive-brand-strong-active' ],
	'primary-fgFill': [
		'foreground-interactive-brand-strong',
		'foreground-interactive-brand-strong-active',
	],
	'primary-surface4': [ 'background-interactive-brand-weak-active' ],
	'primary-fgSurface4': [ 'foreground-interactive-brand-active' ],
	'primary-fgSurface3': [ 'foreground-interactive-brand' ],
	'primary-stroke3': [
		'background-thumb-brand',
		'background-thumb-brand-active',
		'stroke-focus',
		'stroke-interactive-brand',
		'stroke-surface-brand-strong',
	],
	'primary-stroke4': [ 'stroke-interactive-brand-active' ],
	'primary-stroke1': [ 'stroke-surface-brand' ],
	'primary-surface1': [ 'background-surface-brand' ],
	'info-surface2': [ 'background-surface-info-weak' ],
	'info-surface4': [ 'background-surface-info' ],
	'info-fgSurface4': [ 'foreground-content-info' ],
	'info-fgSurface3': [ 'foreground-content-info-weak' ],
	'info-stroke3': [ 'stroke-surface-info-strong' ],
	'info-stroke1': [ 'stroke-surface-info' ],
	'success-surface2': [ 'background-surface-success-weak' ],
	'success-surface4': [ 'background-surface-success' ],
	'success-fgSurface4': [ 'foreground-content-success' ],
	'success-fgSurface3': [ 'foreground-content-success-weak' ],
	'success-stroke3': [ 'stroke-surface-success-strong' ],
	'success-stroke1': [ 'stroke-surface-success' ],
	'warning-surface2': [ 'background-surface-warning-weak' ],
	'warning-surface4': [ 'background-surface-warning' ],
	'warning-fgSurface4': [ 'foreground-content-warning' ],
	'warning-fgSurface3': [ 'foreground-content-warning-weak' ],
	'warning-stroke3': [ 'stroke-surface-warning-strong' ],
	'warning-stroke1': [ 'stroke-surface-warning' ],
	'error-bgFill1': [ 'background-interactive-error-strong' ],
	'error-bgFill2': [ 'background-interactive-error-strong-active' ],
	'error-fgFill': [
		'foreground-interactive-error-strong',
		'foreground-interactive-error-strong-active',
	],
	'error-surface2': [
		'background-interactive-error-active',
		'background-surface-error-weak',
	],
	'error-surface4': [
		'background-interactive-error-weak-active',
		'background-surface-error',
	],
	'error-fgSurface4': [
		'foreground-content-error',
		'foreground-interactive-error-active',
	],
	'error-fgSurface3': [
		'foreground-content-error-weak',
		'foreground-interactive-error',
	],
	'error-stroke3': [
		'stroke-interactive-error',
		'stroke-interactive-error-strong',
		'stroke-surface-error-strong',
	],
	'error-stroke4': [ 'stroke-interactive-error-active' ],
	'error-stroke1': [ 'stroke-surface-error' ],
	'bg-surface2': [ 'background-surface-neutral' ],
	'bg-surface5': [
		'background-interactive-brand-strong-disabled',
		'background-interactive-error-strong-disabled',
		'background-interactive-neutral-strong-disabled',
	],
	'bg-surface4': [ 'background-interactive-neutral-weak-active' ],
	'bg-surface3': [
		'background-interactive-neutral',
		'background-interactive-neutral-active',
		'background-interactive-neutral-disabled',
		'background-surface-neutral-strong',
	],
	'bg-fgSurface4': [
		'foreground-content-neutral',
		'foreground-interactive-neutral',
		'foreground-interactive-neutral-active',
		'foreground-interactive-neutral-weak-active',
	],
	'bg-fgSurface3': [
		'foreground-content-neutral-weak',
		'foreground-interactive-neutral-weak',
	],
	'bg-fgSurface2': [
		'foreground-interactive-brand-disabled',
		'foreground-interactive-brand-strong-disabled',
		'foreground-interactive-error-disabled',
		'foreground-interactive-error-strong-disabled',
		'foreground-interactive-neutral-disabled',
		'foreground-interactive-neutral-strong-disabled',
		'foreground-interactive-neutral-weak-disabled',
	],
	'bg-stroke3': [
		'background-thumb-neutral-weak',
		'stroke-interactive-neutral',
		'stroke-surface-neutral-strong',
	],
	'bg-stroke4': [
		'background-thumb-neutral-weak-active',
		'stroke-interactive-neutral-active',
		'stroke-interactive-neutral-strong',
	],
	'bg-stroke2': [
		'background-thumb-brand-disabled',
		'background-thumb-neutral-weak-disabled',
		'background-track-neutral',
		'stroke-interactive-brand-disabled',
		'stroke-interactive-error-disabled',
		'stroke-interactive-neutral-disabled',
		'stroke-surface-neutral',
	],
	'bg-stroke1': [
		'background-track-neutral-weak',
		'stroke-surface-neutral-weak',
	],
	'bg-bgFillInverted2': [ 'background-interactive-neutral-strong-active' ],
	'bg-bgFillInverted1': [ 'background-interactive-neutral-strong' ],
	'bg-fgFillInverted': [
		'foreground-interactive-neutral-strong',
		'foreground-interactive-neutral-strong-active',
	],
	'bg-surface1': [ 'background-surface-neutral-weak' ],
	'caution-surface2': [ 'background-surface-caution-weak' ],
	'caution-surface4': [ 'background-surface-caution' ],
	'caution-fgSurface4': [ 'foreground-content-caution' ],
	'caution-fgSurface3': [ 'foreground-content-caution-weak' ],
	'caution-stroke3': [ 'stroke-surface-caution-strong' ],
	'caution-stroke1': [ 'stroke-surface-caution' ],
} as Record< string, string[] >;
